export default __webpack_public_path__ + "static/media/project1.98f5db15.jpg";